import classNames from 'classnames'
import React from 'react'
import { Link } from 'react-router'
import { Routes, t } from 'shared'

export const StartCampaignButton = ({
  primary,
  query = null,
  text,
  style = {},
  className,
}: {
  primary?: boolean
  query?: Record<string, string | number> | null
  text?: string | null
  style?: React.CSSProperties
  className?: string
}) => (
  <Link
    to={Routes.newCampaignPath('campaign', query)}
    role="button"
    className={classNames(`ui large button primary`, { ['basic']: !primary }, className)}
    style={style}
  >
    {text || t('campaign.start_button_text.default')}
  </Link>
)
